(() => {
  if (window.__productCardFinishPreview) return;
  window.__productCardFinishPreview = true;

  const SWATCH_SELECTOR = '[data-product-card-finish-preview]';
  const SWATCH_LIST_SELECTOR = '.product-card__swatch-list';
  const HOVER_MEDIA = window.matchMedia('(hover: hover) and (pointer: fine)');
  const PREVIEW_REMOVAL_DELAY = 220;
  const stateByCard = new WeakMap();

  function getOrCreateState(swatch) {
    const card = swatch.closest('product-card');
    if (!card) return null;

    let state = stateByCard.get(card);
    if (!state) {
      state = { card, request: 0, preview: null };
      stateByCard.set(card, state);
    }

    return state;
  }

  function waitForImage(image) {
    if (image.complete) return Promise.resolve(image.naturalWidth > 0);

    return new Promise((resolve) => {
      image.addEventListener('load', () => resolve(true), { once: true });
      image.addEventListener('error', () => resolve(false), { once: true });
    });
  }

  async function preview(swatch) {
    const state = getOrCreateState(swatch);
    const template = swatch.querySelector('[data-product-card-finish-preview-template]');
    const figureLink = state?.card.querySelector('.product-card__figure > a');
    const image = template?.content.firstElementChild?.cloneNode(true);

    if (!state || !figureLink || !(image instanceof HTMLImageElement)) return;

    const request = ++state.request;
    figureLink.append(image);

    const loaded = await waitForImage(image);
    if (!loaded || request !== state.request) {
      image.remove();
      return;
    }

    const previousPreview = state.preview;
    state.preview = image;

    requestAnimationFrame(() => {
      if (request === state.request) {
        previousPreview?.classList.remove('is-ready');
        image.classList.add('is-ready');
        state.card.classList.add('product-card--finish-preview-active');

        if (previousPreview) {
          window.setTimeout(() => previousPreview.remove(), PREVIEW_REMOVAL_DELAY);
        }
      }
    });
  }

  function reset(swatch) {
    const card = swatch.closest('product-card');
    if (!card) return;

    const state = stateByCard.get(card);
    if (!state) return;

    state.request += 1;
    card.classList.remove('product-card--finish-preview-active');

    const previewImage = state.preview;
    state.preview = null;
    if (!previewImage) return;

    previewImage.classList.remove('is-ready');
    previewImage.addEventListener('transitionend', () => previewImage.remove(), {
      once: true,
    });
    window.setTimeout(() => previewImage.remove(), PREVIEW_REMOVAL_DELAY);
  }

  document.addEventListener('pointerover', (event) => {
    if (!HOVER_MEDIA.matches) return;

    const swatch = event.target.closest?.(SWATCH_SELECTOR);
    if (swatch && !swatch.contains(event.relatedTarget)) preview(swatch);
  });

  function resetWhenLeavingSwatches(event) {
    const swatchList = event.target.closest?.(SWATCH_LIST_SELECTOR);
    if (!swatchList) return;

    const nextSwatch = event.relatedTarget?.closest?.(SWATCH_SELECTOR);
    if (nextSwatch && swatchList.contains(nextSwatch)) return;

    const swatch = swatchList.querySelector(SWATCH_SELECTOR);
    if (swatch) reset(swatch);
  }

  document.addEventListener('pointerout', resetWhenLeavingSwatches);

  document.addEventListener('focusin', (event) => {
    const swatch = event.target.closest?.(SWATCH_SELECTOR);
    if (swatch) preview(swatch);
  });

  document.addEventListener('focusout', resetWhenLeavingSwatches);
})();
